/* eslint-disable */
import {
    Box,
    Button,
    ButtonGroup,
    Flex,
    Grid,
    IconButton,
    Select,
    Text,
    useBreakpointValue,
    HStack,
    VStack,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    FormControl,
    FormLabel,
    Input,
    RadioGroup,
    Radio,
    CheckboxGroup,
    Checkbox,
    Stack,
    Progress,
    Badge,
    Heading,
    Spinner,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { AddIcon, EditIcon } from "@chakra-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import convertDateFormat, {
  deleteProduct,
  getTeacherCourses,
} from "../../Redux/TeacherReducer/action";
import Pagination from "../Adminitems/Pagination";
import TeacherNavTop from "./TeacherNavTop";
import Navbar from "../UserComponents/UserNavbar";
import axios from "axios";
import { DEPARTMENTS } from "../../constants/departments";
import { useModalToast } from "../../context/GlobalModalToast";


export default function TeacherCourses() {
    const store = useSelector((store) => store.TeacherReducer.data);
    const dispatch = useDispatch();
  const { toast, confirm } = useModalToast();
    const [coursesList, setCoursesList] = useState([]);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [order, setOrder] = useState("");
    const limit = 4;
    const tableSize = useBreakpointValue({ base: "sm", sm: "md", md: "lg" });
    const courseSize = useBreakpointValue({ base: "md", sm: "lg", md: "xl" });
  
    const { isOpen: isAssignOpen, onOpen: onAssignOpen, onClose: onAssignClose } = useDisclosure();
    const { isOpen: isReportOpen, onOpen: onReportOpen, onClose: onReportClose } = useDisclosure();
    const [activeCourseId, setActiveCourseId] = useState("");
    const [activeCourseTitle, setActiveCourseTitle] = useState("");
    const [assignMode, setAssignMode] = useState("individual");
    const [assignEmail, setAssignEmail] = useState("");
    const [assignDept, setAssignDept] = useState("All");
    const [assignDueDate, setAssignDueDate] = useState("");
    const [isAssigning, setIsAssigning] = useState(false);
    const [enrollmentReport, setEnrollmentReport] = useState([]);
    const [isReportLoading, setIsReportLoading] = useState(false);

    const handleSearch = (e) => {
      setSearch(e.target.value);
    };
    const handleSelect = (e) => {
      const { value } = e.target;
      setOrder(value);
    };
  
    useEffect(() => {
      dispatch(getTeacherCourses());
    }, [dispatch]);

    useEffect(() => {
      if (store) {
        setCoursesList(store);
      }
    }, [store]);
  
    const handleDelete = (id, title) => {
      dispatch(deleteProduct(id));
      setCoursesList(prev => prev.filter(c => c._id !== id));
      toast({ title: `${title} is Deleted`, status: "success", duration: 2000 });
    };

    const handleToggleInviteOnly = async (courseId) => {
      try {
        const token = JSON.parse(localStorage.getItem('user'))?.token || "";
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/${courseId}/toggle-invite-only`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        setCoursesList(prev => prev.map(c => c._id === courseId ? { ...c, isInviteOnly: res.data.isInviteOnly } : c));
        toast({ title: res.data.message, status: "info" });
      } catch (err) {
        toast({ title: "Error toggling invite-only status: " + (err.response?.data?.message || err.message), status: "info" });
      }
    };

    const handleToggleStatus = async (courseId) => {
      try {
        const token = JSON.parse(localStorage.getItem('user'))?.token || "";
        const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/${courseId}/toggle-status`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        setCoursesList(prev => prev.map(c => c._id === courseId ? { ...c, isDisabled: res.data.isDisabled } : c));
        toast({ title: "Status Updated", description: res.data.message, status: "success", duration: 2000 });
      } catch (err) {
        toast({ title: "Error", description: err.response?.data?.message || "Failed to update course status", status: "error" });
      }
    };

    const handleOpenAssignModal = (courseId, courseTitle) => {
      setActiveCourseId(courseId);
      setActiveCourseTitle(courseTitle);
      onAssignOpen();
    };

    const handleOpenProgressReport = async (courseId, courseTitle) => {
      setActiveCourseId(courseId);
      setActiveCourseTitle(courseTitle);
      onReportOpen();
      setIsReportLoading(true);
      try {
        const token = JSON.parse(localStorage.getItem('user'))?.token || "";
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/enrollments/course/${courseId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setEnrollmentReport(res.data);
      } catch (err) {
        console.error("Failed to load course progress report", err);
      } finally {
        setIsReportLoading(false);
      }
    };

    const handleAssignSubmit = async () => {
      if (assignMode === 'individual') {
        if (!assignEmail.trim()) {
          toast({ title: "Please enter a valid employee email address.", status: "info" });
          return;
        }
        setIsAssigning(true);
        try {
          const token = JSON.parse(localStorage.getItem('user'))?.token || "";
          await axios.post(`${process.env.REACT_APP_API_URL}/api/courses/${activeCourseId}/invite`, {
            email: assignEmail,
            dueDate: assignDueDate || undefined
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });
          toast({ title: `Successfully invited ${assignEmail} to this course!`, status: "success", duration: 2000 });
          onAssignClose();
          setAssignEmail("");
          setAssignDueDate("");
        } catch (err) {
          toast({ title: "Failed to send invite: " + (err.response?.data?.message || err.message), status: "info" });
        } finally {
          setIsAssigning(false);
        }
      } else {
        setIsAssigning(true);
        try {
          const token = JSON.parse(localStorage.getItem('user'))?.token || "";
          const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/enrollments/bulk-assign`, {
            courseId: activeCourseId,
            department: assignDept,
            dueDate: assignDueDate || undefined
          }, {
            headers: { Authorization: `Bearer ${token}` }
          });
          toast({ title: res.data.message, status: "info" });
          onAssignClose();
          setAssignDueDate("");
        } catch (err) {
          toast({ title: "Failed to complete group assignment: " + (err.response?.data?.message || err.message), status: "info" });
        } finally {
          setIsAssigning(false);
        }
      }
    };
  
    const handlePageChange = (page) => {
      setPage(page);
    };
    const count = 4;
  
    const handlePageButton = (val) => {
      setPage((prev) => prev + val);
    };
  
    return (
      <Grid className="Nav" h={"99vh"} w="94%" gap={10}>
        {/* <AdminSidebar/>  */}
        <Box mt='90px'>
            <TeacherNavTop handleSearch={handleSearch} />
          {/*  */}
          <Box className={`course ${courseSize}`}>
            <Grid
              templateColumns={{
                xl: "repeat(3,20% 60% 20%)",
                lg: "repeat(3,20% 60% 20%)",
                base: "repeat(1,1fr)",
              }}
              gap={{ xl: 0, lg: 0, base: 7 }}
            >
              <Text fontWeight={"bold"}>Welcome To Course</Text>
              <Box></Box>
              <Flex justify="flex-end" gap={4} fontWeight={"bold"}>
                <Button 
                  size="sm" 
                  colorScheme="blue" 
                  onClick={() => {
                    const token = JSON.parse(localStorage.getItem('user'))?.token || "";
                    window.open(`${process.env.REACT_APP_API_URL}/api/reports/progress/excel?token=${token}`, '_blank');
                  }}
                >
                  All Courses Excel
                </Button>
                <Link to="/Teacher/addCourse">
                  <Button size="sm" colorScheme="purple">Create Course</Button>
                </Link>
              </Flex>
            </Grid>
            <Box
              w={{ xl: "100%", lg: "90%", md: "80%", base: "80%" }}
              overflowX="auto"
            >
              <Table
                variant="striped"
                borderRadius="md"
                w="100%"
                size={tableSize}
              >
                <Thead>
                  <Tr>
                    <Th>Title</Th>
                    <Th>Date</Th>
                    <Th>Category</Th>
                    <Th>Description</Th>
                    <Th>Instructor</Th>
                    <Th>Actions & Privacy</Th>
                  </Tr>
                </Thead>
                {coursesList?.length > 0 &&
                  coursesList?.map((el, i) => {
                    return (
                      <Tbody key={i}>
                        <Tr>
                          <Td fontWeight="semibold">
                            {el.title}
                            {el.isDisabled && (
                              <Badge ml={2} colorScheme="red" variant="solid" borderRadius="full" px={2} py={0.5} fontSize="9px" fontWeight="800">
                                🛑 DISABLED
                              </Badge>
                            )}
                          </Td>
                          <Td>{convertDateFormat(el.createdAt)}</Td>
                          <Td>{el.category}</Td>
                          <Td maxW="200px" isTruncated>{el.description}</Td>
                          <Td>{el.teacher}</Td>
                          <Td>
                            <VStack align="stretch" spacing={2}>
                              <HStack spacing={2}>
                                <Button
                                  size="sm"
                                  colorScheme="red"
                                  variant="ghost"
                                  onClick={() => handleDelete(el._id, el.title)}
                                >
                                  Delete
                                </Button>
                                <Link to={`/Teacher/edit/${el._id}`}>
                                  <Button size="sm" colorScheme="blue" variant="outline">
                                    Edit Course
                                  </Button>
                                </Link>

                              </HStack>
                              
                              <HStack spacing={2} wrap="wrap">
                                <Button
                                  size="xs"
                                  colorScheme={el.isInviteOnly ? "orange" : "green"}
                                  onClick={() => handleToggleInviteOnly(el._id)}
                                >
                                  {el.isInviteOnly ? "🔒 Private" : "🔓 Public"}
                                </Button>
                                <Button
                                  size="xs"
                                  colorScheme={el.isDisabled ? "green" : "red"}
                                  onClick={() => handleToggleStatus(el._id)}
                                >
                                  {el.isDisabled ? "✅ Enable" : "🛑 Disable"}
                                </Button>
                                <Button
                                  size="xs"
                                  colorScheme="purple"
                                  onClick={() => handleOpenAssignModal(el._id, el.title)}
                                >
                                  + Assign Training
                                </Button>
                                <Button
                                  size="xs"
                                  colorScheme="blue"
                                  onClick={() => handleOpenProgressReport(el._id, el.title)}
                                >
                                  📊 Compliance
                                </Button>
                              </HStack>
                            </VStack>
                          </Td>
                        </Tr>
                      </Tbody>
                    );
                  })}
              </Table>
            </Box>
            <Box textAlign={{ xl: "right", lg: "right", base: "left" }} display="flex" gap={2} justifyContent={{ xl: "flex-end", lg: "flex-end", base: "flex-start" }} alignItems="center">
              <Button 
                colorScheme="purple" 
                variant="outline" 
                borderRadius="xl"
                isDisabled={page <= 1} 
                onClick={() => handlePageButton(-1)}
              >
                Prev
              </Button>
              <Pagination
                totalCount={count}
                current_page={page}
                handlePageChange={handlePageChange}
              />
              <Button
                colorScheme="purple" 
                variant="outline" 
                borderRadius="xl"
                isDisabled={page >= count}
                onClick={() => handlePageButton(1)}
              >
                Next
              </Button>
            </Box>
          </Box>
        </Box>

        {/* ASSIGN TRAINING MODAL */}
        <Modal isOpen={isAssignOpen} onClose={onAssignClose} size="lg">
          <ModalOverlay backdropFilter="blur(8px)" />
          <ModalContent borderRadius="2xl" overflow="hidden" boxShadow="2xl">
            <ModalHeader className="premium-gradient" color="white" py={5}>
              <VStack align="flex-start" spacing={1}>
                <Text fontSize="lg" fontWeight="800">🎯 Assign Corporate Training</Text>
                <Text fontSize="xs" opacity={0.9} fontWeight="semibold">Course: {activeCourseTitle}</Text>
              </VStack>
            </ModalHeader>
            <ModalCloseButton color="white" top={4} />
            <ModalBody p={6} bg="gray.50">
              <VStack spacing={5} align="stretch">
                <FormControl>
                  <FormLabel fontWeight="700" color="gray.700" fontSize="sm">Assignment Mode</FormLabel>
                  <RadioGroup value={assignMode} onChange={setAssignMode} colorScheme="purple">
                    <HStack spacing={6}>
                      <Radio value="individual">👤 Individual Employee</Radio>
                      <Radio value="group">👥 Group / Department</Radio>
                    </HStack>
                  </RadioGroup>
                </FormControl>

                {assignMode === 'individual' ? (
                  <FormControl isRequired>
                    <FormLabel fontWeight="700" color="gray.700" fontSize="sm">Employee Corporate Email</FormLabel>
                    <Input 
                      placeholder="employee@company.com" 
                      bg="white" 
                      borderRadius="xl"
                      value={assignEmail} 
                      onChange={(e) => setAssignEmail(e.target.value)} 
                    />
                  </FormControl>
                ) : (
                  <FormControl isRequired>
                    <FormLabel fontWeight="700" color="gray.700" fontSize="sm">Select Target Department / Sector</FormLabel>
                    <Select 
                      bg="white" 
                      borderRadius="xl" 
                      value={assignDept} 
                      onChange={(e) => setAssignDept(e.target.value)}
                    >
                      <option value="All">All Corporate Departments</option>
                      {DEPARTMENTS.map((dept) => (
                        <option key={dept} value={dept}>{dept}</option>
                      ))}
                    </Select>
                  </FormControl>
                )}

                <FormControl>
                  <FormLabel fontWeight="700" color="gray.700" fontSize="sm">Set Training Due Date (Optional)</FormLabel>
                  <Input 
                    type="date" 
                    bg="white" 
                    borderRadius="xl"
                    value={assignDueDate} 
                    onChange={(e) => setAssignDueDate(e.target.value)} 
                  />
                  <Text fontSize="xs" color="gray.500" mt={1}>
                    Leave empty if there is no deadline. Overdue indicators will trigger automatically after this date.
                  </Text>
                </FormControl>
              </VStack>
            </ModalBody>
            <ModalFooter bg="gray.100" borderTop="1px solid" borderColor="gray.200" py={4}>
              <Button variant="ghost" borderRadius="xl" onClick={onAssignClose} mr={3}>
                Cancel
              </Button>
              <Button 
                className="premium-gradient hover-lift" 
                color="white" 
                borderRadius="xl" 
                onClick={handleAssignSubmit}
                isLoading={isAssigning}
                loadingText="Assigning..."
              >
                Confirm Assignment
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* LIVE COMPLIANCE & PROGRESS REPORT MODAL */}
        <Modal isOpen={isReportOpen} onClose={onReportClose} size="full">
          <ModalOverlay backdropFilter="blur(8px)" />
          <ModalContent m={6} borderRadius="3xl" overflow="hidden" boxShadow="2xl">
            <ModalHeader className="premium-gradient" color="white" py={6}>
              <Flex align="center" justify="space-between" wrap="wrap" gap={4}>
                <VStack align="flex-start" spacing={1}>
                  <Heading size="md" fontWeight="800">📊 Compliance & Progress Dashboard</Heading>
                  <Text fontSize="sm" opacity={0.9} fontWeight="semibold">Real-time status for course: {activeCourseTitle}</Text>
                </VStack>
                
                <HStack spacing={3}>
                  <Button 
                    size="sm" 
                    colorScheme="whiteAlpha" 
                    onClick={() => {
                      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
                      window.open(`${process.env.REACT_APP_API_URL}/api/reports/progress/csv/${activeCourseId}?token=${token}`, '_blank');
                    }}
                  >
                    📥 Download CSV Report
                  </Button>
                  <Button 
                    size="sm" 
                    colorScheme="whiteAlpha"
                    bg="white"
                    color="purple.700"
                    _hover={{ bg: 'gray.100' }}
                    onClick={() => {
                      const token = JSON.parse(localStorage.getItem('user'))?.token || "";
                      window.open(`${process.env.REACT_APP_API_URL}/api/reports/progress/excel/${activeCourseId}?token=${token}`, '_blank');
                    }}
                  >
                    📥 Download styled XLSX Excel
                  </Button>
                </HStack>
              </Flex>
            </ModalHeader>
            <ModalCloseButton color="white" top={6} />
            <ModalBody p={8} overflowY="auto" bg="gray.50">
              {isReportLoading ? (
                <VStack py={20} spacing={4}>
                  <Spinner size="xl" color="purple.500" />
                  <Text color="gray.500" fontWeight="600">Generating compliance report...</Text>
                </VStack>
              ) : enrollmentReport.length === 0 ? (
                <VStack py={20} spacing={2} textAlign="center">
                  <Text fontSize="xl" fontWeight="700" color="gray.700">No Assignments Yet</Text>
                  <Text color="gray.500">This course has not been assigned or enrolled by any corporate employee yet.</Text>
                </VStack>
              ) : (
                <Box overflowX="auto" bg="white" borderRadius="2xl" boxShadow="sm" p={4} border="1px solid" borderColor="gray.100">
                  <Table variant="simple" size="md">
                    <Thead bg="gray.50">
                      <Tr>
                        <Th fontWeight="800">Employee</Th>
                        <Th fontWeight="800">Department</Th>
                        <Th fontWeight="800">Sector</Th>
                        <Th fontWeight="800" textAlign="center">Compliance Status</Th>
                        <Th fontWeight="800">Course Progress</Th>
                        <Th fontWeight="800">Due Date</Th>
                        <Th fontWeight="800" textAlign="center">Overdue</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {enrollmentReport.map((item, idx) => {
                        const isOverdue = item.dueDate && new Date() > new Date(item.dueDate) && item.status !== 'Completed';
                        let badgeColor = "gray";
                        let statusText = item.status || "Not Started";

                        if (item.status === 'Completed') badgeColor = "green";
                        else if (item.status === 'In Progress') badgeColor = "orange";
                        else if (item.status === 'Not Started') badgeColor = "yellow";

                        if (isOverdue) {
                          badgeColor = "red";
                          statusText = "Overdue ⏰";
                        }

                        return (
                          <Tr key={idx} _hover={{ bg: 'gray.50/50' }}>
                            <Td>
                              <Box>
                                <Text fontWeight="700" color="gray.800">{item.userId?.fullName || 'N/A'}</Text>
                                <Text fontSize="xs" color="gray.500">{item.userId?.email || 'N/A'}</Text>
                              </Box>
                            </Td>
                            <Td fontWeight="semibold" color="gray.600">{item.userId?.department || 'N/A'}</Td>
                            <Td color="gray.500">{item.userId?.sector || 'N/A'}</Td>
                            <Td textAlign="center">
                              <Badge 
                                colorScheme={badgeColor} 
                                variant="solid" 
                                borderRadius="full" 
                                px={3.5} 
                                py={1} 
                                fontSize="xs"
                                fontWeight="800"
                              >
                                {statusText}
                              </Badge>
                            </Td>
                            <Td minW="150px">
                              <VStack align="stretch" spacing={1}>
                                <Text fontSize="xs" fontWeight="700" textAlign="right" color="purple.700">
                                  {item.progress}%
                                </Text>
                                <Progress 
                                  value={item.progress} 
                                  size="xs" 
                                  colorScheme={item.status === 'Completed' ? 'green' : 'purple'} 
                                  borderRadius="full" 
                                />
                              </VStack>
                            </Td>
                            <Td fontWeight="semibold" color={isOverdue ? 'red.600' : 'gray.600'}>
                              {item.dueDate ? new Date(item.dueDate).toLocaleDateString() : 'N/A'}
                            </Td>
                            <Td textAlign="center">
                              {isOverdue ? (
                                <Badge colorScheme="red" variant="subtle" borderRadius="xl" px={2.5}>Yes ⏰</Badge>
                              ) : (
                                <Text color="gray.400" fontSize="sm">-</Text>
                              )}
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </Box>
              )}
            </ModalBody>
          </ModalContent>
        </Modal>
      </Grid>
    );
}
